import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Usuario } from "../../../models/usuario";
import { environment } from "environments/environment";
import { IID, INTEGRADOR_UUID } from '../../../shared/auth/auth.service';
import { AbUsuario } from "app/abstract/full-pages/admin/usuario.abstract";

@Injectable({
  providedIn: 'root'
})
export class UsuarioService extends AbUsuario {
  url = environment.urlApi;

  getUsuario(): Observable<any> {
    const uuid = sessionStorage.getItem(INTEGRADOR_UUID);
    if (uuid) {
      return this.getAll(`api/v1/usuarios/me/integrador/${uuid}`);
    }

    const integradorId = sessionStorage.getItem(IID);
    return this.get(`api/v1/usuarios/me/integrador/${integradorId}`);
  }

  getAllTenantsUsuario(): Observable<any> {
    const uuid = sessionStorage.getItem(INTEGRADOR_UUID);
    if (uuid) {
      return this.getAll(`api/v1/usuarios/me/tenants/integrador/${uuid}`);
    }

    const integradorId = sessionStorage.getItem(IID);
    return this.getAll(`api/v1/usuarios/me/tenants/integrador/${integradorId}`);
  }

  alterarSenha(alterarSenha: any): Observable<any> {
    alterarSenha.id = -1;
    return this.save("public/usuarios/alterar_senha/", alterarSenha);
  }

  recuperarSenhaByEmailAndIntegradorId(email: string, id: number): Observable<any> {
    return this.get(`public/usuarios/disparar_email_confirmacao/${email}/${id}`);
  }

  getCustomSkin(): Observable<any> {
    const urlIntegrador = { url: window.location.href.split('//')[1].split('/')[0] }
    return this.post("public/custom_skin/", urlIntegrador);
  }

  getUsuarioByEmail(email: string): Observable<any> {
    return this.get(`public/usuarios/email/${email}`);
  }

  getUsuarioByPessoaId(id: number, isSigma: boolean): Observable<any> {
    return this.get(`api/v1/usuarios/person/${id}`, undefined, { isSigma });
  }

  alterarLogin(usuario: Usuario): Observable<any> {
    return this.http.put(`${this.url}api/v1/usuarios/${usuario.id}/login`, { login: usuario.login });
  }

  registrarPrimeiroAcesso(): Observable<any> {
    return this.get(`api/v1/usuarios/me/first-access`);
  }

  validarSenha(senha: string): Observable<any> {
    const usuario = {
      senha: senha
    }
    return this.post('api/v1/usuarios/me/validate-password', usuario);
  }

  validarToken(token: string): Observable<any> {
    return this.get(`public/usuarios/validar_token_redefinicao_senha/${token}`);
  }

  redefinirSenhaPorToken(token: string, alterarSenha: any): Observable<any> {
    return this.put(`public/usuarios/redefinir_senha_por_token`, token, alterarSenha);
  }

  alterarHabilitarMfa(idUsuario: number, habilitarMFA: boolean, motivo: string): Observable<any> {
    const mfaRequest = {
      "habilitarMfa": habilitarMFA,
      "motivo": motivo
    }
    return this.http.put(`${this.url}api/v1/usuarios/${idUsuario}/mfa`, mfaRequest);
  }

  getMfaConfig(idUsuario: number): Observable<any> {
    return this.get(`api/v1/usuarios/${idUsuario}/mfa/status`);
  }

  confirmarExclusaoConta(token: string): Observable<any> {
    return this.get(`public/exclusao_usuarios/registrar/${token}`);
  }

}
